import { createFileRoute, redirect } from '@tanstack/react-router';

import { TokenManager } from '../auth/TokenManager';
import { queries } from '../common/api/queryKeys/queries';
import { AdminMemberDetailPage } from '../user/detail/AdminMemberDetailPage';
import { Role } from '../user/model/role.model';
import { SessionService } from '../user/session/SessionService';

export const Route = createFileRoute('/_app/members/$id')({
    beforeLoad: async ({ context }) => {
        const token = await TokenManager.getInstance().getToken();
        const role = await context.queryClient.ensureQueryData<Role>({
            queryKey: queries.role.information.queryKey,
            queryFn: () => SessionService.getInstance().loadRoleInformation(token),
        });

        if (!role.isSuperAdmin()) {
            throw redirect({ to: '/settings' });
        }
    },
    component: AdminMemberDetailPage,
});
